import * as Cities from 'Modules/CityModule';
import { City } from '../EnumTypes/ActionEnumTypes';

const init = () => ({
  type: City.GET_POPULAR_CITIES_INIT,
});

export const success = (data) => ({
  type: City.GET_POPULAR_CITIES_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: City.GET_POPULAR_CITIES_FAILURE,
});

const getPopularCities = () => async (dispatch) => {
  dispatch(init());
  try {
    const response = await Cities.Connector.getPopularCities();
    dispatch(success(response.data));
    return response.data;
  } catch (err) {
    dispatch(failure());
    return false;
  }
};

export default getPopularCities;
